import { h2 } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div ``;
const Title = styled.h2 `
  ${h2};
  padding-bottom: 10px;
  margin-bottom: 30px;
  border-bottom: 4px solid var(--themeColor);
`;
export const FeaturedArticleStyles = {
    Container,
    Title,
};
